import { UILibraryComponentProps } from '@core/types';
import React from 'react';
import { Typography } from '../../components/Typography';

export const PostTitle: React.FC<UILibraryComponentProps> = (props) => (
  <Typography component="h1" textSize={3} margin={0} {...props} />
);
